import { useFlags } from "~/features/feature-flags"

/** The column chooser redesign (`columnChooserV2`); off unless the flag says otherwise. */
export function useColumnChooserV2(): boolean {
  const { columnChooserV2 } = useFlags()
  return columnChooserV2 === true
}
